import { gql } from '@apollo/client'
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core'

import * as Types from './purchasePlus_graphql'

export const AccountChildrenModalAccountFragmentDoc = gql`
  fragment AccountChildrenModalAccount on Account {
    id
  }
` as unknown as DocumentNode<Types.AccountChildrenModalAccountFragment, unknown>
